import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'app/models/user.model';
import { UserService } from 'app/services/users/user.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css']
})
export class VerificationComponent implements OnInit {

  constructor(private router: Router, private userService: UserService) { }

  user$: Observable<User> = this.userService.user$;

  ngOnInit(): void {
  }

  toLogin(){
    this.router.navigate(['']);
  }

  async sendEmail(){
    await this.userService.sendVerificationEmail();
  }

}
